module.exports = __webpack_public_path__ + "static/media/google-icon.ce321e89.svg";